Promise.all([import('embla-carousel'), import('scripts/marmalade/extensions/embla-plugins'), import('@meteora-digital/modal'), import('scripts/elements/modal')]).then(_ref => {
  let [moduleEmbla, moduleEmblaPlugins, moduleModal] = _ref;
  // Define the components
  const ModalController = moduleModal.default;
  const EmblaCarousel = moduleEmbla.default;
  // Grab the plugins
  const {
    addDotBtnsAndClickHandlers,
    addPrevNextBtnsClickHandlers
  } = moduleEmblaPlugins;
  DomObserver.observe('.js-default-gallery', blocks => {
    blocks.forEach(block => {
      // Create a new modal
      const Modal = new ModalController({
        removeFromDOM: false,
        parent: block
      });

      // The gallery list
      const list = block.querySelector('.js-default-gallery__list');

      // If we have no list, return
      if (!list) return;

      // The gallery items
      const items = [...list.children];

      // If we have no items in the list, return
      if (items.length === 0) return;

      // Find the slider modal
      const modal = block.querySelector('.js-default-gallery__modal');
      // Find the container
      const container = block.querySelector('.js-default-gallery__container');
      // Find the slider
      const slider = block.querySelector('.js-default-gallery__slider');
      if (slider.children.length === 0) return;

      // Set up the Embla Carousel
      const embla = EmblaCarousel(container, {
        loop: true
      });
      // Create a new div for the dots
      const dotsNode = document.createElement('div');
      // Create a previous button
      const prevBtn = document.createElement('button');
      // Create a next button
      const nextBtn = document.createElement('button');

      // Set the classes for the dots, previous, and next buttons
      dotsNode.classList.add('embla-dots');
      prevBtn.classList.add('embla-button', 'embla-button--prev');
      prevBtn.setAttribute('aria-label', 'Previous slide');
      nextBtn.classList.add('embla-button', 'embla-button--next');
      nextBtn.setAttribute('aria-label', 'Next slide');

      // Add the dots to the slider
      modal.appendChild(dotsNode);
      // Add the previous button to the slider
      container.appendChild(prevBtn);
      // Add the next button to the slider
      container.appendChild(nextBtn);
      let settled = true;
      const removeVideos = () => {
        [...modal.querySelectorAll('iframe')].forEach(iframe => {
          iframe.parentNode.removeChild(iframe);
        });
      };

      // When the modal opens, lock the scroll
      Modal.on('open', () => {
        window.ScrollLocker.lock();
      });

      // When the modal closes, unlock the scroll
      Modal.on('close', () => {
        window.ScrollLocker.unlock();
        removeVideos();
      });

      // When the slide changes remove the videos
      embla.on('settle', () => {
        settled = true;
      });
      embla.on('scroll', () => {
        if (!settled) return;
        settled = false;
        removeVideos();
      });

      // Loop through each item
      items.forEach((item, i) => {
        // Find the action button
        const action = item.querySelector('.js-default-gallery__action');

        // Open the modal when the action button is clicked
        action.addEventListener('click', () => {
          Modal.open();
          // Go to the correct slide
          embla.scrollTo(i);
        });
      });

      // Append the modal modal to the modal
      Modal.append(modal);

      // Add the dot buttons and click handlers
      addDotBtnsAndClickHandlers(embla, dotsNode);
      addPrevNextBtnsClickHandlers(embla, prevBtn, nextBtn);
    });
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});